import {
  DropdownOptions,
  Flex,
  LocalCashTables,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  TooltipPopup,
} from 'dash-ui';

import DeleteOrganizationModal from 'pages/organizations/components/DeleteOrganizationModal/DeleteOrganizationModal';

import OrganizationsTable from './components/OrganizationsTable/OrganizationsTable';
import OrganizationsTableHeader from './components/OrganizationsTableHeader/OrganizationsTableHeader';
import ConfirmationDeleteOrganizationModal from '../components/ConfirmationDeleteOrganizationModal/ConfirmationDeleteOrganizationModal';

function OrganizationsPage() {
  return (
    <PaginationProvider storageTableName={LocalCashTables.ORGANIZATIONS}>
      <SortProvider>
        <SearchProvider>
          <ModalProvider>
            <Flex flexDirection="column" flex={1} w="100%">
              <DropdownOptions />
              <TooltipPopup />
              <OrganizationsTableHeader />
              <OrganizationsTable />
              <DeleteOrganizationModal />
              <ConfirmationDeleteOrganizationModal />
            </Flex>
          </ModalProvider>
        </SearchProvider>
      </SortProvider>
    </PaginationProvider>
  );
}

export default OrganizationsPage;
